import React from "react";
//#region types
import { PaymentListProps } from "models/propTypes/paymentPropTypes";
import { IconDefinitionConstants } from "utils/constants";
//#endregion
//#region components
import { Icon, MenuButton, RoundButton, TableAsync } from "components/common";
import { Grid } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const PaymentList: React.FC<PaymentListProps> = (props) => {
  const getMoreActionsButton = (index: number, row: any) => (
    <MenuButton
      menuPlacement="bottom"
      menuItems={props.moreActions ? props.moreActions(row) : []}
      button={
        <RoundButton className={cssExports.tableListMoreActions}>
          <Icon icon={IconDefinitionConstants.WEllipsisH} />
        </RoundButton>
      }
      disablePopperPortal={false}
      classes={{
        menuOpen: cssExports.tableListMoreActionsMenuOpen,
      }}
    />
  );
  const getProperties = () => {
    return props.moreActions
      ? {
          ...props.properties,
          moreActions: {
            formatter: (row: any, rowIndex: number) => getMoreActionsButton(rowIndex, row),
            width: 24,
          },
        }
      : props.properties;
  };
  return (
    <Grid container item className={cssExports.tableListContainer}>
      <TableAsync<any>
        properties={getProperties()}
        filter={props.items ?? []}
        pagination="advanced"
        includeSummary
        maxRowCount={20}
        disableSort
        orderByProperty="id"
        orderByDescending
        allowCheckBoxSelection
        disableCheckBoxSelectionForRows={props.disableRowSelection}
        onRowSelectionsChange={props.onRowSelectionsChange}
        disableQueryPagination
        stayOnCurrentPage
        rowClickHandler={props.onRowClick}
      />
    </Grid>
  );
};

export default PaymentList;
